import React from 'react';
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Form from './form.jsx'
import Loader from '../layout/loader.jsx'
import { toast } from 'react-toastify'
import API from '../../services/api.jsx'

class ProjectsNew extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: false,
			breadcrumb: {title: 'Back to projects', path: '/projects'},
			entity: {
				name: null,
				slides: [],
				tags: [],
				clientName: null,
				year: null
			}
		}
		this.saveEntity = this.saveEntity.bind(this)
	}

	saveEntity(fields) {
		this.setState({ loading: true })
		const newFiles = fields.newFiles

		const data = {
			name: fields.name,
			tags: fields.tags.filter(it => it !== null),
			clientName: fields.clientName,
			year: fields.year
		}

		API.createOrUpdateProject(data, newFiles).then(() => {
			toast.success('Project has been updated')
			this.props.history.push('/projects')
		}).catch((err) => {
			if (err.response.data.message === 'Project exists') {
				toast.error('Project exists, please check again')
				this.setState({ loading: false })
			} else {
				toast.error('An unexpected error has occured, please try again')
				this.setState({ loading: false })
			}
		})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head /*title={'New project'}*/ breadcrumb={this.state.breadcrumb} />
				<Content>
					<Form new cancel={() => this.props.history.push('/projects')} save={this.saveEntity} entity={this.state.entity} />
				</Content>
			</>
	}
}

export default ProjectsNew;
